/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ActionConfigVO } from '../model';
// @ts-ignore
import { LayerActionVO } from '../model';
// @ts-ignore
import { LayerAttributeVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * ActionsControllerApi - axios parameter creator
 * @export
 */
export const ActionsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Metoda pro vytvoření akcí
         * @param {number} layerId 
         * @param {ActionConfigVO} actionConfigVO Objekt akce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAction: async (layerId: number, actionConfigVO: ActionConfigVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('createAction', 'layerId', layerId)
            // verify required parameter 'actionConfigVO' is not null or undefined
            assertParamExists('createAction', 'actionConfigVO', actionConfigVO)
            const localVarPath = `/api/actions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionConfigVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro odebrání akce
         * @param {number} layerId 
         * @param {number} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAction: async (layerId: number, actionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('deleteAction', 'layerId', layerId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('deleteAction', 'actionId', actionId)
            const localVarPath = `/api/actions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }

            if (actionId !== undefined) {
                localVarQueryParameter['actionId'] = actionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí všechny atributy dané akce.
         * @param {number} idAkce ID akce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionAttributes: async (idAkce: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idAkce' is not null or undefined
            assertParamExists('getActionAttributes', 'idAkce', idAkce)
            const localVarPath = `/api/actions/action-attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idAkce !== undefined) {
                localVarQueryParameter['idAkce'] = idAkce;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí všechny atributy dané akce.
         * @param {number} layerId ID vrstvy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActions: async (layerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getActions', 'layerId', layerId)
            const localVarPath = `/api/actions/all-actions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro získání všech akci vrstvy
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActions: async (layerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getAllActions', 'layerId', layerId)
            const localVarPath = `/api/actions/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro update akcí
         * @param {number} actionId 
         * @param {number} layerId 
         * @param {ActionConfigVO} actionConfigVO Objekt akce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAction: async (actionId: number, layerId: number, actionConfigVO: ActionConfigVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('updateAction', 'actionId', actionId)
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('updateAction', 'layerId', layerId)
            // verify required parameter 'actionConfigVO' is not null or undefined
            assertParamExists('updateAction', 'actionConfigVO', actionConfigVO)
            const localVarPath = `/api/actions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (actionId !== undefined) {
                localVarQueryParameter['actionId'] = actionId;
            }

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionConfigVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionsControllerApi - functional programming interface
 * @export
 */
export const ActionsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Metoda pro vytvoření akcí
         * @param {number} layerId 
         * @param {ActionConfigVO} actionConfigVO Objekt akce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAction(layerId: number, actionConfigVO: ActionConfigVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.createAction(layerId, actionConfigVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro odebrání akce
         * @param {number} layerId 
         * @param {number} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAction(layerId: number, actionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAction(layerId, actionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrátí všechny atributy dané akce.
         * @param {number} idAkce ID akce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionAttributes(idAkce: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LayerAttributeVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionAttributes(idAkce, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrátí všechny atributy dané akce.
         * @param {number} layerId ID vrstvy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActions(layerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LayerActionVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getActions(layerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro získání všech akci vrstvy
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllActions(layerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActionConfigVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllActions(layerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro update akcí
         * @param {number} actionId 
         * @param {number} layerId 
         * @param {ActionConfigVO} actionConfigVO Objekt akce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAction(actionId: number, layerId: number, actionConfigVO: ActionConfigVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAction(actionId, layerId, actionConfigVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ActionsControllerApi - factory interface
 * @export
 */
export const ActionsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionsControllerApiFp(configuration)
    return {
        /**
         * Metoda pro vytvoření akcí
         * @param {number} layerId 
         * @param {ActionConfigVO} actionConfigVO Objekt akce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAction(layerId: number, actionConfigVO: ActionConfigVO, options?: any): AxiosPromise<void> {
            return localVarFp.createAction(layerId, actionConfigVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro odebrání akce
         * @param {number} layerId 
         * @param {number} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAction(layerId: number, actionId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAction(layerId, actionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí všechny atributy dané akce.
         * @param {number} idAkce ID akce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionAttributes(idAkce: number, options?: any): AxiosPromise<Array<LayerAttributeVO>> {
            return localVarFp.getActionAttributes(idAkce, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí všechny atributy dané akce.
         * @param {number} layerId ID vrstvy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActions(layerId: number, options?: any): AxiosPromise<Array<LayerActionVO>> {
            return localVarFp.getActions(layerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro získání všech akci vrstvy
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActions(layerId: number, options?: any): AxiosPromise<Array<ActionConfigVO>> {
            return localVarFp.getAllActions(layerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro update akcí
         * @param {number} actionId 
         * @param {number} layerId 
         * @param {ActionConfigVO} actionConfigVO Objekt akce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAction(actionId: number, layerId: number, actionConfigVO: ActionConfigVO, options?: any): AxiosPromise<void> {
            return localVarFp.updateAction(actionId, layerId, actionConfigVO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActionsControllerApi - interface
 * @export
 * @interface ActionsControllerApi
 */
export interface ActionsControllerApiInterface {
    /**
     * Metoda pro vytvoření akcí
     * @param {number} layerId 
     * @param {ActionConfigVO} actionConfigVO Objekt akce
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsControllerApiInterface
     */
    createAction(layerId: number, actionConfigVO: ActionConfigVO, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro odebrání akce
     * @param {number} layerId 
     * @param {number} actionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsControllerApiInterface
     */
    deleteAction(layerId: number, actionId: number, options?: any): AxiosPromise<void>;

    /**
     * Vrátí všechny atributy dané akce.
     * @param {number} idAkce ID akce.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsControllerApiInterface
     */
    getActionAttributes(idAkce: number, options?: any): AxiosPromise<Array<LayerAttributeVO>>;

    /**
     * Vrátí všechny atributy dané akce.
     * @param {number} layerId ID vrstvy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsControllerApiInterface
     */
    getActions(layerId: number, options?: any): AxiosPromise<Array<LayerActionVO>>;

    /**
     * Metoda pro získání všech akci vrstvy
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsControllerApiInterface
     */
    getAllActions(layerId: number, options?: any): AxiosPromise<Array<ActionConfigVO>>;

    /**
     * Metoda pro update akcí
     * @param {number} actionId 
     * @param {number} layerId 
     * @param {ActionConfigVO} actionConfigVO Objekt akce
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsControllerApiInterface
     */
    updateAction(actionId: number, layerId: number, actionConfigVO: ActionConfigVO, options?: any): AxiosPromise<void>;

}

/**
 * ActionsControllerApi - object-oriented interface
 * @export
 * @class ActionsControllerApi
 * @extends {BaseAPI}
 */
export class ActionsControllerApi extends BaseAPI implements ActionsControllerApiInterface {
    /**
     * Metoda pro vytvoření akcí
     * @param {number} layerId 
     * @param {ActionConfigVO} actionConfigVO Objekt akce
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsControllerApi
     */
    public createAction(layerId: number, actionConfigVO: ActionConfigVO, options?: any) {
        return ActionsControllerApiFp(this.configuration).createAction(layerId, actionConfigVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro odebrání akce
     * @param {number} layerId 
     * @param {number} actionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsControllerApi
     */
    public deleteAction(layerId: number, actionId: number, options?: any) {
        return ActionsControllerApiFp(this.configuration).deleteAction(layerId, actionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí všechny atributy dané akce.
     * @param {number} idAkce ID akce.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsControllerApi
     */
    public getActionAttributes(idAkce: number, options?: any) {
        return ActionsControllerApiFp(this.configuration).getActionAttributes(idAkce, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí všechny atributy dané akce.
     * @param {number} layerId ID vrstvy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsControllerApi
     */
    public getActions(layerId: number, options?: any) {
        return ActionsControllerApiFp(this.configuration).getActions(layerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro získání všech akci vrstvy
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsControllerApi
     */
    public getAllActions(layerId: number, options?: any) {
        return ActionsControllerApiFp(this.configuration).getAllActions(layerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro update akcí
     * @param {number} actionId 
     * @param {number} layerId 
     * @param {ActionConfigVO} actionConfigVO Objekt akce
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsControllerApi
     */
    public updateAction(actionId: number, layerId: number, actionConfigVO: ActionConfigVO, options?: any) {
        return ActionsControllerApiFp(this.configuration).updateAction(actionId, layerId, actionConfigVO, options).then((request) => request(this.axios, this.basePath));
    }
}
